export default __webpack_public_path__ + "static/background-e56118806165e79344c1698cd5367d0f.png";